import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const getActivityFeed = (request: GetActivityFeedRequest) => {
  const url = `${apiConfiguration.apiUrl}/activity-feed`;
  return axios.get<ActivityFeedModel>(url, { params: request });
};
